
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {SymbolProfitLossMultipleInfo} from './SymbolProfitLossMultipleInfo';
import {FieldModelSymbolProfitLossMultipleInfo} from './SymbolProfitLossMultipleInfo';

/**
 * SymbolProfitLossMultipleInfoNotify struct
 */
class SymbolProfitLossMultipleInfoNotify {
  /**
   * Initialize struct
   * @param {!Array=} symbolProfitLossMultipleInfo
   * @constructor
   */
  constructor (symbolProfitLossMultipleInfo = []) {
    this.SymbolProfitLossMultipleInfo = symbolProfitLossMultipleInfo
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolProfitLossMultipleInfoNotify}
   * @param {!SymbolProfitLossMultipleInfoNotify} other Other struct
   * @returns {!SymbolProfitLossMultipleInfoNotify} This struct
   */
  copy (other) {
    if (other.SymbolProfitLossMultipleInfo != null) {
      this.SymbolProfitLossMultipleInfo = []
      for (let item of other.SymbolProfitLossMultipleInfo) {
        if (item != null) {
          let tempItem
          tempItem = SymbolProfitLossMultipleInfo.fromObject(item)
          this.SymbolProfitLossMultipleInfo.push(tempItem)
        } else {
          this.SymbolProfitLossMultipleInfo.push(null)
        }
      }
    } else {
      this.SymbolProfitLossMultipleInfo = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolProfitLossMultipleInfoNotify}
   * @returns {!SymbolProfitLossMultipleInfoNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolProfitLossMultipleInfoNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolProfitLossMultipleInfoNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolProfitLossMultipleInfoNotify}
   * @param {!SymbolProfitLossMultipleInfoNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolProfitLossMultipleInfoNotify)) {
      throw new TypeError('Instance of SymbolProfitLossMultipleInfoNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolProfitLossMultipleInfoNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      SymbolProfitLossMultipleInfo: ((this.SymbolProfitLossMultipleInfo != null) ? Array.from(this.SymbolProfitLossMultipleInfo, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolProfitLossMultipleInfoNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolProfitLossMultipleInfoNotify} other Object value
   * @returns {!SymbolProfitLossMultipleInfoNotify} Created struct
   */
  static fromObject (other) {
    return new SymbolProfitLossMultipleInfoNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolProfitLossMultipleInfoNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolProfitLossMultipleInfoNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolProfitLossMultipleInfoNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5225
  }
}

export { SymbolProfitLossMultipleInfoNotify };

/**
 * Fast Binary Encoding SymbolProfitLossMultipleInfoNotify field model
 */
class FieldModelSymbolProfitLossMultipleInfoNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.SymbolProfitLossMultipleInfo = new fbe.FieldModelVector(new FieldModelSymbolProfitLossMultipleInfo(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.SymbolProfitLossMultipleInfo.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.SymbolProfitLossMultipleInfo.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolProfitLossMultipleInfoNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5225
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.SymbolProfitLossMultipleInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolProfitLossMultipleInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolProfitLossMultipleInfo.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!SymbolProfitLossMultipleInfoNotify} fbeValue Default value, defaults is new SymbolProfitLossMultipleInfoNotify()
   * @returns {!SymbolProfitLossMultipleInfoNotify} SymbolProfitLossMultipleInfoNotify value
   */
  get (fbeValue = new SymbolProfitLossMultipleInfoNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!SymbolProfitLossMultipleInfoNotify} fbeValue SymbolProfitLossMultipleInfoNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.SymbolProfitLossMultipleInfo.fbeSize) <= fbeStructSize) {
      this.SymbolProfitLossMultipleInfo.get(fbeValue.SymbolProfitLossMultipleInfo)
    } else {
      fbeValue.SymbolProfitLossMultipleInfo.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolProfitLossMultipleInfo.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {!SymbolProfitLossMultipleInfoNotify} fbeValue SymbolProfitLossMultipleInfoNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolProfitLossMultipleInfoNotify}
   * @param {SymbolProfitLossMultipleInfoNotify} fbeValue SymbolProfitLossMultipleInfoNotify value
   */
  setFields (fbeValue) {
    this.SymbolProfitLossMultipleInfo.set(fbeValue.SymbolProfitLossMultipleInfo)
  }
}

export { FieldModelSymbolProfitLossMultipleInfoNotify };

/**
 * Fast Binary Encoding SymbolProfitLossMultipleInfoNotify model
 */
class SymbolProfitLossMultipleInfoNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolProfitLossMultipleInfoNotify(this.buffer, 4)
  }

  /**
   * Get the SymbolProfitLossMultipleInfoNotify model
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @returns {!FieldModelSymbolProfitLossMultipleInfoNotify} model SymbolProfitLossMultipleInfoNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolProfitLossMultipleInfoNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolProfitLossMultipleInfoNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @param {!SymbolProfitLossMultipleInfoNotify} value SymbolProfitLossMultipleInfoNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @param {!SymbolProfitLossMultipleInfoNotify} value SymbolProfitLossMultipleInfoNotify value, defaults is new SymbolProfitLossMultipleInfoNotify()
   * @return {!object} Deserialized SymbolProfitLossMultipleInfoNotify value and its size
   */
  deserialize (value = new SymbolProfitLossMultipleInfoNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolProfitLossMultipleInfoNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolProfitLossMultipleInfoNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolProfitLossMultipleInfoNotifyModel}
   * @param {!number} prev Previous SymbolProfitLossMultipleInfoNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolProfitLossMultipleInfoNotifyModel };
